import { Outlet } from 'react-router-dom';

import { SubTitle } from 'components/text/SubTitle';
import { Tabs, Typography, neutral } from 'enable-ui';

import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';

import { CustomTabs } from '../styles/tab';

import { COLOR_CONFIG } from 'constants/color';

import { useClassDetailLayoutController } from '../core/controller/class-detail-layout';
import { getClassesDetailTabs } from '../core/tabs';

export const ClassDetailLayout = () => {
  const { locationPath, onTabClick, id, classes, goBack } = useClassDetailLayoutController();

  const tabs = getClassesDetailTabs(id ?? '');

  if (!classes) {
    return null;
  }

  return (
    <div className="full-width">
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <HeaderDetailPage title={classes.name} goBack={goBack} style={{ marginBottom: 0 }} />
        <span style={{ color: COLOR_CONFIG['neutral-text'] }}>&#8226; </span>
        <SubTitle leftTitle={classes.code} rightTitle={`${classes.totalLearner} clients`} />
      </div>
      <CustomTabs>
        <Tabs
          variant="text"
          items={tabs}
          activeKey={locationPath}
          onTabClick={onTabClick}
          tabItemStyle={{
            height: 52,
            background: 'transparent',
          }}
          isLine={true}
        />
      </CustomTabs>

      <div style={{ padding: '16px 0' }}>
        <Outlet />
      </div>
    </div>
  );
};
